import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Complete activity log across the portal." />
      <div className="bg-white border border-border rounded-md overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-secondary hover:bg-secondary">
            <TableHead>Timestamp</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Detail</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="text-xs text-muted-foreground tabular">{(l.timestamp || "").slice(0, 19).replace("T", " ")}</TableCell>
                <TableCell className="font-medium">{l.user_name}</TableCell>
                <TableCell><Badge variant="outline" className="capitalize">{l.action}</Badge></TableCell>
                <TableCell className="text-sm capitalize">{l.entity}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{l.detail}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-12 text-muted-foreground">No activity logged yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
